@if (dialog().isOpen) {
  <div class="modal-backdrop" role="presentation">
    <section class="confirm-modal" role="dialog" aria-modal="true" aria-labelledby="confirmation-title">
      <header class="confirm-modal-header">
        <h2 id="confirmation-title">{{ dialog().title }}</h2>
        <button type="button" class="close-button" (click)="cancel()" aria-label="Close">x</button>
      </header>

      <p class="confirm-copy">{{ dialog().message }}</p>

      @if (dialog().detail) {
        <p class="confirm-meta">{{ dialog().detail }}</p>
      }

      <footer class="confirm-modal-actions">
        <button type="button" class="ghost-action" (click)="cancel()">
          {{ dialog().cancelText }}
        </button>
        <button type="button" [class]="isDanger() ? 'danger-action' : 'primary-action'" (click)="confirm()">
          {{ dialog().confirmText }}
        </button>
      </footer>
    </section>
  </div>
}
